module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAYCAMAAAC/Wk/yAAAAD1BMVEVMaXEyMjIzMzM0NDQzMzM9G5SdAAAABHRSTlMA5kpJG2qUMwAAACtJREFUeNrt0bENAAAIAkFA9p/ZFYitfE1CcRg6iAM6ivlQ2bXwsspU5i6zwxQHJ+4wiwEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/icon-menu.png
// module id = hX8U
// module chunks = 0